export default "__VITE_ASSET__DCh33Ci1__"